import React, { Fragment } from "react";
import agentBanner from "assets/images/YOOZ-WEBSITE-AGENT-BANNER.png";
import ContentWrapper from "components/public-dashboard/components/contentWrapper";
import PageBanner from "components/public-dashboard/components/page_banner";
import AgentHeader from "./header";
import AgentContent from "./content";
import useDocumentTitle from "../../../../hooks/useDocumentTitle";

export default function Agents() {
    useDocumentTitle(
    "Become a Bill Payment Agent | YOOZ",
    "Boost your income, increase your customer base and become a One Stop Shop. Offer your customers the option to pay their utility bills at your store."
  );
  return (
    <Fragment>
      <PageBanner img={agentBanner} />
      <ContentWrapper>
        <AgentHeader />
        <AgentContent />
      </ContentWrapper>
    </Fragment>
  );
}
